import React from "react";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";

const SortBySelect = ({ sort = ["size", "desc"], onChange, label = "Sort By", ...props }) => {
  const handleChange = (e) => {
    const [field, direction] = e.target.value.split(":");
    onChange?.([field, direction]); // pass array back to parent
  };

  return (
    <FormControl fullWidth {...props}>
      <InputLabel>{label}</InputLabel>
      <Select
        value={sort.join(":")}   // encode array as string
        onChange={handleChange}
        label={label}
      >
        <MenuItem value="size:desc">File Size - Large to Small</MenuItem>
        <MenuItem value="size:asc">File Size - Small to Large</MenuItem>
        <MenuItem value="createdAt:desc">Date - New to Old</MenuItem>
        <MenuItem value="createdAt:asc">Date - Old to New</MenuItem>
      </Select>
    </FormControl>
  );
};

export default SortBySelect;